import React from 'react'
import cx from 'classnames'

import { SvgIcon } from '../svg-icon'

import styles from './status-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a status icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <Status02Icon width={12} />
 */
const Status02Icon = ({ className, ...props }) => (
    <SvgIcon {...props} className={cx(className, styles['status-02-icon'])} inheritColor>
        <path
            className={styles['outer']}
            d="M24,39A15,15,0,1,1,39,24,15,15,0,0,1,24,39M24,5.5A18.5,18.5,0,1,0,42.5,24,18.5,18.5,0,0,0,24,5.5"
        />
        <path
            d={`M24,12A12,12,0,1,0,36,24,12,12,0,0,0,24,12Zm6.79,8.85-7.31,7.32-1.06,1a.66.66,0,0,1-.52.21.76.76,0,
                0,1-.56-.21l-4.13-4.16a.76.76,0,0,1,0-1.05L18.26,23a.76.76,0,0,1,1,0l2.59,2.59,6.79-6.75a.74.74,0,0,
                1,1,0l1.05,1A.72.72,0,0,1,30.79,20.85Z`}
        />
    </SvgIcon>
)

Status02Icon.defaultProps = defaultProps

export { Status02Icon }
